import {Tooltip} from '@mui/material';
import React, {createContext, useContext, useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import IconButton from "@mui/material/IconButton";

export const LocalNavigationContext = createContext();

export const LocalNavigationProvider = ({children}) => {

    const [localNavigation, setLocalNavigation] = useState('');

    return (
        <LocalNavigationContext.Provider value={{localNavigation, setLocalNavigation}}>
            {children}
        </LocalNavigationContext.Provider>
    );
};

export const useLocalNavigation = (items, object = undefined) => {

    const {setLocalNavigation} = useContext(LocalNavigationContext);
    const navigate = useNavigate()

    useEffect(() => {
        if (items) {
            setLocalNavigation(
                <>
                    <div style={{borderRight: "2px solid white", display: "inline-block", height: "30px"}}>
                        <span style={{marginLeft: "4px"}}></span>
                    </div>
                    {items.map((item, index) => (
                        <React.Fragment key={index}>
                            <Tooltip title={item.title}>
                                <IconButton color="inherit" onClick={() => navigate(item.url)} sx={{'& svg': {fontSize: "35px"}}}>
                                    {item.icon}
                                </IconButton>
                            </Tooltip>
                        </React.Fragment>
                    ))}
                </>
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setLocalNavigation, object]);
};
